// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-containers-index-js": () => import("./../src/containers/index.js" /* webpackChunkName: "component---src-containers-index-js" */),
  "component---src-containers-create-note-js": () => import("./../src/containers/createNote.js" /* webpackChunkName: "component---src-containers-create-note-js" */),
  "component---src-containers-404-js": () => import("./../src/containers/404.js" /* webpackChunkName: "component---src-containers-404-js" */)
}

